import { useToast } from "@/hooks/use-toast";
import { 
  ToastProvider, 
  ToastViewport, 
  CustomToast, 
  ToastTitle, 
  ToastDescription 
} from "@/components/ui/custom-toast";

export function CustomToaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <CustomToast key={id} variant={variant as any} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
          </CustomToast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
